module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stage-explorer",
    class: {
      collapsed: _vm.collapsed,
      peeking: _vm.collapsed && _vm.peeking
    },
    style: ((!_vm.collapsed || _vm.peeking) ? {
      width: _vm.width + 'px'
    } : null),
    on: {
      "mouseenter": _vm.onMouseEnter,
      "mouseleave": _vm.onMouseLeave,
      "click": _vm.onPanelClick
    }
  }, [(!_vm.collapsed) ? _c('div', {
    staticClass: "se-resize",
    attrs: {
      "title": "Drag to resize"
    },
    on: {
      "mousedown": _vm.startResize
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "se-head"
  }, [(!_vm.collapsed || _vm.peeking) ? _c('span', {
    staticClass: "se-title"
  }, [_vm._v(_vm._s(_vm.selectedStage ? 'Stage Details' : 'Stage Explorer'))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "se-toggle",
    attrs: {
      "title": _vm.collapsed ? 'Expand' : 'Collapse'
    },
    on: {
      "click": function($event) {
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "9 18 15 12 9 6"
    }
  })])])]), _vm._v(" "), (!_vm.collapsed || _vm.peeking) ? _c('div', {
    staticClass: "se-body"
  }, [(_vm.selectedStage) ? _c('div', [_c('button', {
    staticClass: "se-back",
    on: {
      "click": function($event) {
        return _vm.$emit('deselect')
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "12",
      "height": "12",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "15 18 9 12 15 6"
    }
  })]), _vm._v("\n        Back to list\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "se-detail-name"
  }, [_vm._v(_vm._s(_vm.selectedStage.name))]), _vm._v(" "), _c('span', {
    staticClass: "se-badge",
    class: 'se-badge-' + _vm.selectedStage.arche
  }, [_vm._v(_vm._s(_vm.selectedStage.emoji) + " " + _vm._s(_vm.selectedStage.label))]), _vm._v(" "), _c('div', {
    staticClass: "se-tabs"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      staticClass: "se-tab",
      class: {
        active: _vm.activeTab === tab.key
      },
      on: {
        "click": function($event) {
          _vm.activeTab = tab.key
        }
      }
    }, [_vm._v(_vm._s(tab.key === 'comments' ? ("Comments (" + _vm.commentCount + ")") : tab.label))])
  }), 0), _vm._v(" "), (_vm.activeTab === 'content') ? _c('stage-content-tab', {
    attrs: {
      "stage": _vm.selectedStage,
      "lang-options": _vm.langOptions,
      "current-lang": _vm.currentLang,
      "all-stages": _vm.stages
    },
    on: {
      "select-stage": function($event) {
        return _vm.$emit('select-stage', $event)
      },
      "update-message": function($event) {
        return _vm.$emit('update-message', $event)
      },
      "update-topics": function($event) {
        return _vm.$emit('update-topics', $event)
      }
    }
  }) : (_vm.activeTab === 'behavior') ? _c('stage-behavior-tab') : (_vm.activeTab === 'comments') ? _c('stage-comments-tab', {
    attrs: {
      "journey-key": _vm.journeyKey,
      "stage-name": _vm.selectedStage.name
    }
  }) : _vm._e()], 1) : _c('div', [_c('div', {
    staticClass: "se-legend"
  }, _vm._l((_vm.legend), function(item) {
    return _c('div', {
      key: item.key,
      staticClass: "se-legend-item"
    }, [_c('span', {
      staticClass: "se-swatch",
      style: ({
        background: item.bg,
        borderColor: item.border
      })
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.label))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "se-stages-head"
  }, [_vm._v("Stages · " + _vm._s(_vm.stages.length))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterText),
      expression: "filterText"
    }],
    staticClass: "se-filter",
    attrs: {
      "type": "text",
      "placeholder": "Filter stages..."
    },
    domProps: {
      "value": (_vm.filterText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "se-list"
  }, _vm._l((_vm.filteredStages), function(s) {
    return _c('div', {
      key: s.name,
      staticClass: "se-card",
      on: {
        "click": function($event) {
          return _vm.$emit('select-stage', s.name)
        }
      }
    }, [_c('div', {
      staticClass: "se-name"
    }, [_vm._v(_vm._s(s.name))]), _vm._v(" "), _c('div', {
      staticClass: "se-meta"
    }, [_c('span', {
      staticClass: "se-badge",
      class: 'se-badge-' + s.arche
    }, [_vm._v(_vm._s(s.emoji) + " " + _vm._s(s.label))]), _vm._v(" "), _c('span', {
      staticClass: "se-desc"
    }, [_vm._v(_vm._s(s.desc))])])])
  }), 0)])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-e13fcb1c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-journey/journey-flow/StageExplorer.vue
// module id = bdN4
// module chunks = 1